
import FontColors from "../../../assets/filled/FontColors.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FontColorsIcon({ className, dataTestid = "FontColorsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FontColors data-testid={dataTestid} className={classes} {...rest} />
  );
}
